import LockTimerWidget from './lock-timer-widget';

export default LockTimerWidget;